import React from 'react';
import './Password.sass';

export default function Password() {
	return (
		<svg
			width="18px"
			height="20px"
			viewBox="0 0 18 20"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g fill="#E31837">
					<g>
						<path d="M1,19 L17,19 L17,9 L1,9 L1,19 Z M5,8 L5,5 C5,2.794 6.794,1 9,1 C11.206,1 13,2.794 13,5 L13,6 L14,6 L14,5 C14,2.243 11.757,0 9,0 C6.243,0 4,2.243 4,5 L4,8 L0,8 L0,20 L18,20 L18,8 L5,8 L5,8 Z" />
						<polygon points="6 14.5 12 14.5 12 13.5 6 13.5" />
					</g>
				</g>
			</g>
		</svg>
	);
}
